import { candidatesFilterQueryParamsSchema, candidatesOrderingSchema } from "api/resources/hire";
import { offerTypeSchema } from "domains/pros/containers/SendDirectOfferDialog/routing";
import * as z from "zod/mini";

// Shared by the Hire Candidates page and Connect's Applicants tab, which mounts the same list.
export const candidatesSearchSchema = z.extend(candidatesFilterQueryParamsSchema, {
  ordering: z._default(candidatesOrderingSchema, "-review_summary__avg_rating"),
  pro_fullname: z.optional(z.string()),
  tab: z.optional(z.enum(["all", "groups", "favorites"])),
  group_id: z.optional(z.number()),
  candidate_id: z.optional(z.number()),
  job_posting_id: z.optional(z.string()),
  /** Connect's teaser: the top applicant (a job-candidate id) whose profile sheet is open. */
  applicant_id: z.optional(z.string()),
  offerType: offerTypeSchema,
});
export type CandidatesSearch = z.infer<typeof candidatesSearchSchema>;
